import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';

import Footer from './components/Footer';
import Header from './components/Header';
import Router from './components/Router';
import CookieWrapper from './components/cookies/CookieWrapper';

function App() {
    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                refetchOnWindowFocus: false,
            },
        },
    });
    const { i18n, t } = useTranslation();

    return (
        <BrowserRouter
            basename={i18n.resolvedLanguage === 'en' ? `/en/eshop` : `/eshop`}>
            <HelmetProvider>
                <Helmet>
                    <title>{t('header.title')}</title>
                    <meta name="og:type" content="website" />
                </Helmet>
            </HelmetProvider>
            <QueryClientProvider client={queryClient}>
                <div className="mx-auto max-w-[1440px] overflow-auto md:px-14">
                    <Header />

                    <Router />
                    <CookieWrapper />
                </div>

                <Footer />
            </QueryClientProvider>
        </BrowserRouter>
    );
}

export default App;
